import { Text } from "@chakra-ui/react";
import React from "react";

const PhotoFrames = () => {
  return (
    <>
      <Text
        fontWeight={"bold"}
        fontSize={30}
        color={"red"}
        py={5}
        px={5}
        textAlign={"center"}
      >
        Don't worry. It's Us not you. We are working on it
      </Text>
    </>
  );
};

export default PhotoFrames;
